import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form"
import { reducer as toastrReducer} from "react-redux-toastr"

import AuthReducer from "./auth/authReducer"
import CadastroReducerJS from "./modules/seguranca/usuarios/CadastroReducer";
import StockReducerJS from "./modules/relatorios/stock/stockReducer";
import PriceReducerJS from "./modules/relatorios/price/priceReducer";
import CustGprPcgReducerJS from "./modules/relatorios/custGrpPcg/custGrpPcgReducer";
import CustPrdLstReducerJS from "./modules/relatorios/custPrdLst/custPrdLstReducer";
import PrdCmbReducerJS from "./modules/relatorios/prdCmb/prdCmbReducer";
import CustomerReducerJS from "./modules/relatorios/customer/customerReducer";
import OrderReducerJS from "./modules/relatorios/order/orderReducer";

const rootReducer = combineReducers({
    cadastroRed: CadastroReducerJS,
    stockReducer: StockReducerJS,
    priceReducer: PriceReducerJS,
    custGprPcgReducer: CustGprPcgReducerJS,
    custPrdLstReducer: CustPrdLstReducerJS,
    prdCmbRedJS: PrdCmbReducerJS,
    customerRedJS: CustomerReducerJS,
    orderRedJS: OrderReducerJS,
    authRed: AuthReducer,
    form: formReducer,
    toastr: toastrReducer
})

export default rootReducer